import React from "react";
import style from "./index.module.scss";
import { Button, Tooltip } from "antd";
import { BiUndo } from "react-icons/bi";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { SignInInfo, SignType } from "API/signIn";

interface SignHeaderProps {
    data?: SignInInfo;
    type: string; //签到类型
}

export default function SignHeader({ data, type }: SignHeaderProps) {
    const history = useHistory();

    return (
        <div className={style.root}>
            <div>
                <h1 className={style.title}>
                    <Tooltip
                        title={data?.signInModel?.title}
                        placement="bottom">
                        {type === String(SignType.Live) && (
                            <span>{data?.title}</span>
                        )}
                        {type !== String(SignType.Live) && (
                            <span>{data?.signInModel?.title}</span>
                        )}
                    </Tooltip>

                    <Button
                        className={style.back}
                        onClick={() => history.goBack()}>
                        <BiUndo size={16} /> 返回
                    </Button>
                </h1>

                {type !== String(SignType.Live) && (
                    <div className={style.info}>
                        {data?.signInModel?.startTime && (
                            <span>
                                开始时间{" "}
                                {moment(data?.signInModel?.startTime).format(
                                    "MM-DD HH:mm"
                                )}
                            </span>
                        )}
                        {data?.signInModel?.endTime && (
                            <span>
                                ｜ 结束时间{" "}
                                {moment(data?.signInModel?.endTime).format(
                                    "MM-DD HH:mm"
                                )}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
